import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

var searchByInput = function searchByInput(haystack, needle, properties) {
  // searchByInput('users', 'Enoch', ['name', 'email'])
  if (!needle) {
    return haystack;
  } else {
    return haystack.filter(function (item) {
      return properties.some(function (property) {
        return item[property].toString().toLowerCase().includes(needle.toLowerCase());
      });
    });
  }
};

export { searchByInput };